import Cookies from "js-cookie";
import { useAws } from "src/networking/aws";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetDossier,
  GetDossierId,
  PutDossier,
} from "src/types";

export const useGetDossier = <
  T extends GetDossier["request"],
  D extends GetDossier["response"]
>() => {
  const hook = useAws<T, D>("getDossier");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      request.headers = {
        ...request.headers,
        Authorization: Cookies.get("IdToken") || "",
      };
      return hook.crossGate(
        {
          method: "get",
          path: `/dossier`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePutDossier = <
  T extends PutDossier["request"],
  D extends PutDossier["response"]
>(
  gateId: string = "putDossier"
) => {
  const hook = useAws<T, D>(gateId);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      request.headers = {
        ...request.headers,
        Authorization: Cookies.get("IdToken") || "",
      };
      return hook.crossGate(
        {
          method: "put",
          path: `/dossier/switch`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useCreateDossierId = <
  T extends GetDossierId["request"],
  D extends GetDossierId["response"]
>(
  gateId: string = "getDossierId"
) => {
  const hook = useAws<T, D>(gateId);

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      request.headers = {
        ...request.headers,
        Authorization: Cookies.get("IdToken") || "",
      };
      return hook.crossGate(
        {
          method: "post",
          path: `/dossier`,
          ...request,
        },
        callbacks
      );
    },
  };
};
